<template>
  <div>
    <template
      v-if="attributes.length > 0 && variations.length > 0"
    >
      <div
        v-for="attribute in attributes"
        :key="attribute.key"
        class="product__variation"
      >
        <label
          class="product__variation__label"
          :for="'variation-' + attribute.key"
        >{{ attribute.name }}</label>
        <div class="product__variation__field select">
          <select
            :id="'variation-' + attribute.key"
            v-model="selections[attribute.key]"
            :name="attribute.key"
            @change="updateSelectedVariation()"
          >
            <option
              v-for="option in attribute.options"
              :key="option"
              :value="option"
              :disabled="isAttributeDisabled(attribute, option)"
            >
              {{ option }}
              <template v-if="isAttributeDisabled(attribute, option)">
                ({{ $modeoL10n.not_available_with_selected_options }})
              </template>
              <template v-if="getPriceDifference(selections, attribute.key, option).with_tax !== 0 && !hidePrices">
                (<price
                  :price-without-tax="getPriceDifference(selections, attribute.key, option).without_tax"
                  :price-with-tax="getPriceDifference(selections, attribute.key, option).with_tax"
                  :prefix="getPriceDifference(selections, attribute.key, option).with_tax > 0 ? '+':''"
                />)
              </template>
            </option>
          </select>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
    import _ from 'lodash';

    export default {
        props: {
            variations: {
                type: Array,
                default: function () {
                    return [];
                },
            },
            attributes: {
                type: Array,
                default: function () {
                    return [];
                },
            },
            originalSelections: {
                type: Object,
                default: function () {
                    return {};
                },
            },
            hidePrices: Boolean,
        },
        data : function () {
            return {
                selections: {},
                priceWithTax: 0,
                priceWithoutTax: 0,
                regularPriceWithTax: 0,
                regularPriceWithoutTax: 0,
                selectedVariation: null,
                selectedVariationId: null,
            };
        },

        mounted: function () {
            this.setDefaultValues();
        },

        methods: {

            updateSelectedVariation : function() {
                let selections = this.selections;
                let variation = this.findVariation(selections);
                this.selectedVariation = variation;
                this.selectedVariationId = variation.variation_id;
                this.priceWithoutTax = this.selectedVariation.prices_without_tax.price;
                this.priceWithTax = this.selectedVariation.prices_with_tax.price;
                this.regularPriceWithoutTax = this.selectedVariation.prices_without_tax.regular_price;
                this.regularPriceWithTax = this.selectedVariation.prices_with_tax.regular_price;
                this.$emit('change', {
                    selections: selections,
                    selectedVariation: this.selectedVariation,
                    price: {
                        regular_price_without_tax: this.regularPriceWithoutTax,
                        regular_price_with_tax: this.regularPriceWithTax,
                        price_without_tax: this.priceWithoutTax,
                        price_with_tax: this.priceWithTax,
                    },
                })
            },

            findVariation: function(selections) {
                for (let i=0; i < this.variations.length; i++) {
                    let variation = this.variations[i];
                    let matchingVariation = true;
                    for (let attribute in variation.attributes) {
                        if ( Object.prototype.hasOwnProperty.call( variation.attributes, attribute)) {
                            let attributeName = attribute.replace("attribute_", "");
                            // @todo: TypeError: Cannot read property 'toLowerCase' of undefined (selections[attributeName])
                            if (variation.attributes[attribute] !== "" && variation.attributes[attribute].toLowerCase() !== selections[attributeName].toLowerCase()) {
                                matchingVariation = false;
                            }
                        }
                    }

                    if (matchingVariation) {
                        return variation;
                    }
                }
            },

            isAttributeDisabled(attribute, option) {
                let selections = _.clone(this.selections);
                selections[attribute.key] = option;
                let variation = this.findVariation(selections);
                return !variation;
            },

            getPriceDifference(current_selections, attribute, attribute_value) {
                let selections = _.clone(current_selections);
                selections[attribute] = attribute_value;

                let new_variation = this.findVariation(selections);

                if (new_variation && this.selected_variation) {
                    return {
                        with_tax: new_variation.prices_with_tax.price - this.selected_variation.prices_with_tax.price,
                        without_tax: new_variation.prices_without_tax.price - this.selected_variation.prices_without_tax.price,
                    }
                }

                return { with_tax: 0, without_tax: 0 };
            },

            setDefaultValues() {
                if (!_.isEmpty( this.originalSelections )) {
                    this.selections = _.cloneDeep(this.originalSelections);
                } else {
                    let selections = _.cloneDeep(this.selections);
                    this.attributes.forEach(function(attribute) {
                        selections[attribute.key] = attribute.options[0];
                    });
                    this.selections = selections;
                }

                if (this.variations.length > 0) {
                    this.updateSelectedVariation();
                }
            },
        },
    }
</script>
